import * as Antd from 'antd';
import { useEffect } from 'react';

import { useUIStore } from '@/stores';

export const useNotification = () => {
    const { notification } = useUIStore();
    const [api, contextHolder] = Antd.notification.useNotification();

    useEffect(() => {
        if (notification) {
            api.open(notification);
        }
    }, [api, notification]);

    return { contextHolder };
};
